/**
 * Обогащает блюда информацией о местах печати из загруженных привязок.
 *
 * @param {Array} items - Массив элементов меню (блюда и категории)
 * @param {Array} workshopMappings - Привязки блюд к цехам
 * @param {Array} printLocations - Список мест печати
 * @returns {Array} - Обогащённые элементы с полем print_locations
 */
export function enrichItemsWithPrintLocations(items, workshopMappings, printLocations) {
    return items.map(item => {
        if (item.type !== 'dish') {
            return item
        }

        const mapping = workshopMappings.find(m => m.menu_item_id === item.id)

        let printLocationsForItem = []
        if (mapping && mapping.cooking_workshop_ids.length > 0) {
            printLocationsForItem = printLocations
                .filter(loc => mapping.cooking_workshop_ids.includes(loc.id))
                .map(loc => ({
                    id: loc.id,
                    name: loc.name,
                }))
        }

        return {
            ...item,
            print_locations: printLocationsForItem,
        }
    })
}
